import { render } from "./submission-tab-team-members.vue?vue&type=template&id=0f15f8f7&scoped=true&ts=true"
import script from "./submission-tab-team-members.vue?vue&type=script&lang=ts"
export * from "./submission-tab-team-members.vue?vue&type=script&lang=ts"

import "./submission-tab-team-members.vue?vue&type=style&index=0&id=0f15f8f7&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f15f8f7"]])

export default __exports__